// Shown in place of any portfolio amount while hide-balance (the "eye" toggle,
// WalletStateController `isPrivacyModeEnabled`) is on. One constant so the
// headline balance, the allocation donut and every token row mask the same way.
export const HIDDEN_BALANCE_MASK = '••••••••'
